import styled from 'styled-components'

import media from 'utils/media'

export const StyledList = styled.div`
   ${media.greaterThan('md')`
      margin-bottom: ${({ fullWidth }) => (fullWidth ? '33px' : '0')};
   `};

   ${media.greaterThan('lg')`
      margin-bottom: 0;
   `};
`

export const StyledPagination = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   margin-top: 80px;

   ${media.greaterThan('sm')`
      width: 400px;
      margin: 80px auto 0;
   `};

   ${media.greaterThan('md')`
      width: 492px;
   `};

   ${media.greaterThan('lg')`
      width: 485px;
   `};

   ${media.greaterThan('xl')`
      width: 522px;
   `};

   span {
      display: block;
      text-transform: uppercase;
      font-size: 10px;
      font-weight: bold;

      ${media.greaterThan('sm')`
         font-size: 12px;
      `};

      ${media.greaterThan('md')`
         font-size: 14px;
      `};
   }
`
